import { render, staticRenderFns } from "./panel_ximei.vue?vue&type=template&id=8dd29138&scoped=true&"
import script from "./panel_ximei.vue?vue&type=script&lang=js&"
export * from "./panel_ximei.vue?vue&type=script&lang=js&"
import style0 from "./panel_ximei.vue?vue&type=style&index=0&id=8dd29138&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd29138",
  null
  
)

export default component.exports